import * as React from 'react'
import { ITripHistoryObject } from '../../types'
import Star from '../icons/ui/Star'
import TripHistoryDetailSection from './TripHistoryDetailSection'

interface ITripHistoryDriverDetailsProps {
  trip: ITripHistoryObject
}

const TripHistoryDriverDetails = (props: ITripHistoryDriverDetailsProps) => {
  const trip = props.trip
  if (!trip.driver) {
    return null
  }
  return (
    <TripHistoryDetailSection title='Driver'>
      <div className='flex'>
        <img className='circle mr1' src={trip.driver.image} width='40' height='40' />
        <div className='flex-auto flex justify-center flex-column'>
          <div className='flex h6 mb02 items-center bold'>
            {(trip.driver.firstName + ' ' + trip.driver.lastName).trim()}{' '}
            <span className='ml1 h6 flex items-center'>
              <Star className='svg-orange mr1' height={16} width={16} />
              {trip.driver.rating}
            </span>
          </div>
          <div className='font-grey h6'>{`${trip.provider} by ${trip.service.name}`}</div>
        </div>
      </div>
      <div className='h6 ml4 mt1'>{trip.driver.phone}</div>
    </TripHistoryDetailSection>
  )
}

export default TripHistoryDriverDetails



// WEBPACK FOOTER //
// ./src/components/trips/TripHistoryDriverDetails.tsx